import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import GlobalContext from "../../framework/GlobalContext";
import classes from "./StockRequestReport.module.css";
import StockRequestReportFilter from "./StockRequestReportFilter";
import StockRequestReportSummary from "./StockRequestReportSummary";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import Autocomplete from "../../framework/Autocomplete";
import StockRequestDetails from "./stockRequestDetails";

const StockRequestReport = () => {
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const [showStockRequestDetails, setShowStockRequestDetails] = useState(false);
  const { currentComponent, setCurrentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const refreshRef = useRef();
  const enterRef = useRef();
  const exportRef = useRef();

  const refreshData = useCallback((filterData = {}) => {
    reportRef.current.applyFilters(filterData);
  }, []);
  const quickExportHandler = () => {
    reportRef?.current?.quickExport({ fileName: "StockRequestReport" });
  };
  const listener = useCallback((e) => {
    const key = e.key?.toLowerCase();
    const ctrlKey = e.ctrlKey;
    const altKey = e.altKey;
    if (altKey && key === "r") {
      refreshRef.current.click();
      return;
    }
    if (ctrlKey && key === "i") {
      enterRef.current.click();
      return;
    }
    if (key === "enter") {
      enterRef.current.click();
      return;
    }
  }, []);

  const closeStockRequestDetails = useCallback(() => {
    setShowStockRequestDetails(false);
    setCurrentComponent("grid_reports");
    refreshRef.current.click();
  }, [setCurrentComponent]);

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={enterRef}
        startIcon={
          <>
            <Shortcut keys={["Enter"]} />/<Shortcut keys={["Ctrl", "I"]} />
          </>
        }
        label="info"
        onClick={() => {
          setShowStockRequestDetails(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [currentRowData]);
  useEffect(() => {
    if (!onFilterShow && !onColumnShow && currentComponent === "grid_reports") {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow]);
  useEffect(() => {
    refreshData({ isFilterChanged: true, ...filterStates });
  }, [refreshData, filterStates]);
  return (
    <div className={classes["stock-request-report-container"]}>
      <Reports
        identifier="stockRequestReport"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        currentRow={setCurrentRowData}
        onCellClicked={(params) => {
          if (params.column.colId === "stockRequestId") {
            if (params.data.stockRequestId) setShowStockRequestDetails(true);
          }
        }}
        filters={
          <StockRequestReportFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            onFilterShow={onFilterShow}
          />
        }
      />
      <Autocomplete
        show={showStockRequestDetails}
        height="60%"
        closeAutoComplete={closeStockRequestDetails}
      >
        <StockRequestDetails
          stockRequestId={currentRowData?.data?._id}
          onEscape={closeStockRequestDetails}
        />
      </Autocomplete>
      <StockRequestReportSummary
        refreshData={refreshData}
        refreshRef={refreshRef}
        quickExport={quickExportHandler}
        exportRef={exportRef}
      />
    </div>
  );
};

export default StockRequestReport;
